module.exports = __webpack_public_path__ + "static/media/tw.7816cf21.png";